import logoMilled from "@/shop/assets/logo_milled.png"
import logoReadymade from "@/shop/assets/logo_readymade.png"
import logoSmalls from "@/shop/assets/logo_smalls.png"
import logoXtracts from "@/shop/assets/logo_xtracts.png"
import placeholderDefault from "@/shop/assets/placeholder.jpg"

/**
 * Product logos of the prepared (Defektur) types. They have no photo of their own, so the logo stands
 * in for the product image everywhere an article is shown without a shop image.
 */
const PREPARED_TYPE_LOGOS: Record<string, string> = {
    readymade: logoReadymade,
    milled: logoMilled,
    smalls: logoSmalls,
    xtracts: logoXtracts,
}

/** Image to show for an article without an own shop image. */
export function articlePlaceholderImage(type: string | null | undefined): string {
    return PREPARED_TYPE_LOGOS[type ?? ""] ?? placeholderDefault
}
